import React, { Component } from 'react'
import AppConfig from '../../config/app'
import ButtonExt from '../controls/ButtonExt'
import {BtnPermissions, BtnType} from "../../lib/BtnPermissions"
import * as common from '../../lib/common'

export default class TrangThaiView extends Component {
  constructor(props) {
    super(props);
  }
  chkApproveCLick = ({target}) => {
    this.props.chkApproveCLick(this.props.order, target.checked)
  }
  render() {
    const {
      order,
      khoIds
    } = this.props

    const isProcessEnabled = order.TrangThai === AppConfig.ORDER_STATUS.HoanThanhNhap && khoIds.includes(order.KhoId)
    const isApproveEnabled = order.TrangThai === AppConfig.ORDER_STATUS.DangXuLy && khoIds.includes(order.KhoId)
    return (
      <div className="col-xs-12">
        <div>{common.getOrdetStatusText(order.TrangThai, true)}</div>
        {isProcessEnabled && (
          <ButtonExt size="xs" btnClass="pull-right mr-1" btnClick={() => this.props.processOrderClick(order)} 
            iconClass="fa-clock-o" displayText="Xử lý đơn" color="primary" 
            permission={BtnPermissions.DonHang.PROCESS_ORDER} />
        )}
        {isApproveEnabled && (
          <ButtonExt btnClass="form-check-input" 
            btnType={BtnType.Checkbox}
            btnClick={this.chkApproveCLick}
            iconClass="fa-clock-o"
            btnTitle="Tích chọn và bấm Hoàn thành để hoàn thành đơn"
            displayText="Hoàn thành"
            btnId={order.Id}
            btnValue={"1"}
            permission={BtnPermissions.DonHang.APPROVE_ORDER} />
        )}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/views/Orders/_TrangThaiView.js